<div class="card-header bg-white d-flex justify-content-between align-items-center">
    <div>
        <i class="fas fa-user text-gray text-opacity-50"></i>
        Información Personal
    </div>
    @if(!editData){
    <button class="btn btn-white btn-sm border-0 text-gray" (click)="editDataForm()"><i class="fas fa-edit"></i> Editar</button>
    }
</div>

@if(!insured){
    <app-state-display state="loading"></app-state-display>
}

@if(insured && !editData){
<div class="card-body p-3 text-dark">
    <dl class="row mb-0">
        <div class="col-lg-6 col-md-6 col-sm-6 mb-2">
            <dt class="fw-bold"><i class="fa fa-user"></i> Nombre Completo</dt>
            <dd class="mb-0 fs-6">{{insured.names}} {{insured.surname}} {{insured.lastname}}</dd>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 mb-2">
            <dt class="fw-bold"><i class="fa fa-envelope"></i> Correo</dt>
            <dd class="mb-0 text-break">{{insured.mail | lowercase}}</dd>
        </div>
        <div class="col-lg-2 col-sm-3 col-6 mb-2">
            <dt class="fw-bold"><i class="fa fa-id-card"></i> RUT</dt>
            <dd class="mb-0 text-truncate">{{insured.rut | numberPipe}}-{{insured.dv}}</dd>
        </div>
        <div class="col-lg-3 col-sm-3 col-6 mb-2">
            <dt class="fw-bold"><i class="fa fa-building"></i> Campo</dt>
            <dd class="mb-0 text-truncate">{{insured.campus ? insured.campus.acronym : 'Sin contratos activos'}}</dd>
        </div>
        <div class="col-lg-3 col-sm-3 col-6 mb-2">
            <dt class="fw-bold"><i class="fa fa-briefcase"></i> Cargo</dt>
            <dd class="mb-0 text-truncate">{{insured.position?.name || 'No definido'}}</dd>
        </div>
        <div class="col-lg-4 col-sm-3 col-6 mb-2">
            <dt class="fw-bold"><i class="fa fa-venus-mars"></i> Género</dt>
            <dd class="mb-0 text-truncate">{{insured.gender?.code }} - {{insured.gender?.name }}</dd>
        </div>
        <div class="col-lg-4 col-sm-3 col-6 mb-2">
            <dt class="fw-bold"><i class="fa fa-calendar"></i> Nacimiento</dt>
            <dd class="mb-0 text-truncate">{{insured.birthdate | date:'dd-MM-yyyy': 'UTC'}}</dd>
        </div>
        <div class="col-lg-4 col-sm-3 col-6 mb-2">
            <dt class="fw-bold"><i class="fa fa-hourglass-half"></i> Edad</dt>
            <dd class="mb-0">{{insured.age}} años</dd>
        </div>
        <div class="col-lg-4 col-sm-3 col-6 mb-2">
            <dt class="fw-bold"><i class="fa fa-phone"></i> Teléfono</dt>
            <dd class="mb-0 text-truncate">{{insured.phone}}</dd>
        </div>

    </dl>
</div>
}

@if(editData){
<div class="card-body p-3 text-dark" [formGroup]="personalDataForm">
    <div class="row g-2">
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 mt-2">
            <label class="fw-bold">Nombres <small class="text-danger">*</small></label>
            <input type="text" class="form-control" formControlName="names" placeholder="Nombres" (blur)="capitalize('names')">
            @if(personalDataForm.get('names').touched && personalDataForm.get('names').invalid){
                <small class="text-danger">Dato Obligatorio</small>
            }
        </div>
        <div class="col-lg-3 col-sm-6 col-12 mt-2">
            <label class="fw-bold">Apellido Paterno <small class="text-danger">*</small></label>
            <input type="text" class="form-control" formControlName="surname" placeholder="Apellido Paterno" (blur)="capitalize('surname')">
            @if(personalDataForm.get('surname').touched && personalDataForm.get('surname').invalid){
                <small class="text-danger">Dato Obligatorio</small>
            }
        </div>
        <div class="col-lg-3 col-sm-6 col-12 mt-2">
            <label class="fw-bold">Apellido Materno <small class="text-danger">*</small></label>
            <input type="text" class="form-control" formControlName="lastname" placeholder="Apellido Materno" (blur)="capitalize('lastname')">
            @if(personalDataForm.get('lastname').touched && personalDataForm.get('lastname').invalid){
                <small class="text-danger">Dato Obligatorio</small>
            }
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 mt-2">
            <label class="fw-bold">Correo <small class="text-danger">*</small></label>
            <input type="email" class="form-control" formControlName="mail" placeholder="Correo de contacto">
            @if(personalDataForm.get('mail').touched && personalDataForm.get('mail').invalid){
                <small class="text-danger">Dato Obligatorio</small>
            }
        </div>
        <div class="col-lg-3 col-sm-4 col-12 mt-2">
            <label class="fw-bold">RUT <small class="text-danger">*</small></label>
            <input type="text" class="form-control" formControlName="rut" placeholder="Sin puntos ni guión" (blur)="setDigitVerificator()">
            @if(personalDataForm.get('rut').touched && personalDataForm.get('rut').invalid){
                <small class="text-danger">Dato Obligatorio</small>
            }
        </div>
        <div class="col-lg-3 col-sm-2 col-12 mt-2">
            <label class="fw-bold">DV <small class="text-danger">*</small></label>
            <label class="form-control">{{personalDataForm.value.dv || '-'}}</label>
        </div>
        <div class="col-lg-3 col-sm-6 col-12 mt-2">
            <label class="fw-bold">Teléfono <small class="text-danger">*</small></label>
            <input type="tel" class="form-control" formControlName="phone" placeholder="569XXXXXXXX">
            @if(personalDataForm.get('phone').touched && personalDataForm.get('phone').hasError('phoneInvalid')){
                <small class="text-danger">Formato inválido</small>
            }
        </div>
        <div class="col-lg-3 col-sm-6 col-12 mt-2">
            <label class="fw-bold">Cargo</label>
            <ng-select [items]="listPositions" bindLabel="name" bindValue="_id" formControlName="jobTitleId"></ng-select>
        </div>
        <div class="col-lg-3 col-sm-6 col-12 mt-2">
            <label class="fw-bold">Género <small class="text-danger">*</small></label>
            <ng-select [items]="listGenders" bindLabel="name" bindValue="_id" formControlName="genderId"></ng-select>
            @if(personalDataForm.get('genderId').touched && personalDataForm.get('genderId').invalid){
                <small class="text-danger">Dato Obligatorio</small>
            }
        </div>
        <div class="col-lg-3 col-sm-6 col-12 mt-2">
            <label class="fw-bold">Fecha Nacimiento <small class="text-danger">*</small></label>
            <input type="date" class="form-control" formControlName="birthdate" [max]="maxDate" [min]="minDate">
            @if(personalDataForm.get('birthdate').touched && personalDataForm.get('birthdate').hasError('notAdult')){
                <small class="text-danger">Debe ser mayor de edad</small>
            }@else if(personalDataForm.get('birthdate').touched && personalDataForm.get('birthdate').hasError('futureDate')){
                <small class="text-danger">No puede ser una fecha posterior a hoy</small>
            }
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-12 d-flex justify-content-end gap-2 flex-wrap">
            <button class="btn btn-outline-secondary btn-xs" (click)="cancelEdit()"><i class="fas fa-times"></i> Cancelar</button>
            <button class="btn btn-primary btn-xs" (click)="saveData()"><i class="fas fa-save"></i> Guardar</button>
        </div>
    </div>
</div>
}